<template>
    <div class="shop-header">
        <nav class="navbar navbar-expand-lg navbar-light shadow-reg" style="background-color: white;">
            <h2 class="display-4 navbar-brand montserrat-bold mb-0" v-text="currentPageTitle"></h2>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#shop-navigation" aria-controls="shop-navigation" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div ref="navbarCollapse" class="collapse navbar-collapse" id="shop-navigation">
                <ul class="navbar-nav mr-auto">
                    <router-link v-for="(link, key) in links" :key="key" :to="link" v-slot="{ href, route, navigate, isExactActive }">
                        <li :class="[isExactActive && 'active', 'nav-item']">
                            <a :href="href" @click="navigate" class="nav-link" v-text="route.name"></a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </nav>
    </div>
</template>
<script>
import { pageRoute } from "@utils/network";

export default {
    name: "ShopSidebar",

    computed: {
        isNavbarCollapseShowing() {
            return this.$refs.navbarCollapse
                && this.$refs.navbarCollapse.classList.contains("show");
        },
        currentPageTitle() {
            return this.$route.name
        },
        links() {
            return [
                pageRoute("/shops/:id/about", { id: this.shop.id }, false),
                pageRoute("/shops/:id/services", { id: this.shop.id }, false),
                pageRoute("/shops/:id/schedueles", { id: this.shop.id }, false),
                pageRoute("/shops/:id/experts", { id: this.shop.id }, false),
                // pageRoute("/shops/:id/gallery", { id: this.shop.id }, false),
                pageRoute("/shops/:id/vouchers", { id: this.shop.id }, false),
            ]
        },
    },

    methods: {
        
        collapseNavbar(event) {
            if ($(event.target).hasClass("navbar-toggler") || !this.$refs.navbarCollapse) {
                return;
            }
            this.$refs.navbarCollapse.classList.remove("show")
        },
    },

    mounted() {
        
        $(document).click((event) => this.collapseNavbar(event));
        $(document).scroll((event) => this.collapseNavbar(event));
    },

    props: {
        shop: Object
    }
}
</script>
<style scoped>
.navbar {
    border-radius: 6px;
    box-shadow: 0px 3px 6px 1px rgba(0,54,78,0.16);
    margin-bottom: 20px;
}
</style>